exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flex[data-v-6cd4eaae]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.text_overflow[data-v-6cd4eaae]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:400px}", ""]);

// exports
